import React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { AVAILABILITY, DAILY_OPTION, HOURLY_OPTION, PACKAGES } from '../../../SpaceListingConstants';
import PackageComponent from '../../../Common/Packages';
import PricingAndAvailability from '../../../Common/PricingAndAvailablity';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

const DailyPricing = ({ chargingType }) => {
  const country = useSelector((state) => state?.locationMeta?.data?.country_longCode?.replace(" ", "-") || null);
  const baseRouteURL = `/${country}/dashboard/list-a-space/pricing_options/daily/`;

  return (
    <>
      <Switch>
        <Route
          path={baseRouteURL + AVAILABILITY}
          component={() => {
            return <PricingAndAvailability
              pricingOption={DAILY_OPTION}
              chargingType={chargingType}
            />;
          }}
        />

        <Route
          path={baseRouteURL + PACKAGES}
          component={() => {
            return <PackageComponent pricingOption={DAILY_OPTION} />;
          }}
        />
        <Route
          path={'*'}
          component={() => <Redirect to={baseRouteURL + AVAILABILITY} />}
        />
      </Switch>
    </>
  );
}

export default DailyPricing;
